import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import ReactSelect from "react-select";
import "./EmpresaPerfil.css";
import etiqueta from "../../../../../Componentes/Logos/chatby-silver-partner.png";
import { countriesDialCodeAndFlags, timezones } from "../../../../../Componentes/Paises";

const EmpresaPerfil = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const location = useLocation();
  const [selectedDialCode, setSelectedDialCode] = useState("");
  const [countryName, setCountryName] = useState("");
  const [countryCode, setCountryCode] = useState("");
  const [mensajeSubmit, setMensajeSubmit] = useState("");
  const [flags, setFlags] = useState({});
  const [flagsLoading, setFlagsLoading] = useState(true);

  const {
    companyName,
    companyCountry,
    companyAbout,
    classification,
    imgSrc,
    Url,
    email,
  } = location.state || {};

  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    business_name: "",
    email: "",
    whatsapp: "",
    whatsappDialCode: "",
    country: "",
    website: "",
    project_description: "",
    partner: {
      name: location.state?.companyName,
      email: location.state?.email,
    },
  });

  useEffect(() => {
    const getCountryName = () => {
      const countryTimezone = new Intl.DateTimeFormat().resolvedOptions().timeZone;
      const countryCode = timezones[countryTimezone]?.c[0];
      if (countryCode) {
        const country = countriesDialCodeAndFlags.find(
          (c) => c.code === countryCode
        );
        return country ? country.name : "";
      }
      return "";
    };

    const name = getCountryName();
    const country = countriesDialCodeAndFlags.find((c) => c.name === name);

    if (country) {
      setSelectedDialCode(country.dial_code);
      setCountryName(name);
      setCountryCode(country.code);
      setFormData((prevData) => ({
        ...prevData,
        country: name,
        whatsappDialCode: country.dial_code,
      }));
    }
  }, []);

  useEffect(() => {
    const fetchFlags = async () => {
      const newFlags = {};
      const flagRequests = countriesDialCodeAndFlags.map(async (country) => {
        try {
          const response = await axios.get(`https://restcountries.com/v3.1/name/${country.name}`);
          newFlags[country.code] = response.data[0].flags.png || response.data[0].flags.svg;
        } catch (error) {
          newFlags[country.code] = 'default_flag.png';
        }
      });
      await Promise.all(flagRequests);
      setFlags(newFlags);
      setFlagsLoading(false);
    };

    fetchFlags();
  }, []);

  const options = countriesDialCodeAndFlags.map((country) => ({
    value: country.code,
    label: (
      <img
        src={flags[country.code] || 'default_flag.png'}
        alt={`${country.name} flag`}
        style={{ width: '24px', height: '16px' }}
      />
    ),
  }));

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [id]: value }));
  };

  const handleCountryChange = (selectedOption) => {
    if (selectedOption) {
      const selectedCountryCode = selectedOption.value;
      const country = countriesDialCodeAndFlags.find(
        (c) => c.code === selectedCountryCode
      );

      if (country) {
        setCountryName(country.name);
        setCountryCode(country.code);
        setSelectedDialCode(country.dial_code);
        setFormData((prevData) => ({
          ...prevData,
          country: country.name,
          whatsappDialCode: country.dial_code,
        }));
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const fullWhatsappNumber = formData.whatsappDialCode + formData.whatsapp;
    const dataToSend = {
      ...formData,
      whatsapp: fullWhatsappNumber,
    };

    try {
      await axios.post(
        "https://hook.us1.make.com/qblycr3xcc80d5i5j7n1w61vvvywpd03",
        JSON.stringify(dataToSend),
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      setMensajeSubmit("Formulario enviado correctamente");
    } catch (error) {
      console.error("Error:", error);
      setMensajeSubmit("Ocurrió un error al enviar el formulario.");
    }
    setTimeout(() => {
      setMensajeSubmit("");
    }, 5000);
  };

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  if (!location.state?.companyCountry) {
    return <p>No se Encuentra el partner Seleccionado</p>;
  }

  return (
    <section>
      <a href="https://chatby.io/partners" className="return-perfil-partners">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="15px"
          height="15px"
          viewBox="0 0 15 15"
          version="1.1"
        >
          <g id="surface1">
            <path
              fill="currentColor"
              d="M 5.359375 1.984375 L 0.109375 7.234375 C -0.0351562 7.378906 -0.0351562 7.617188 0.109375 7.765625 L 5.359375 13.015625 C 5.507812 13.160156 5.742188 13.160156 5.890625 13.015625 C 6.035156 12.867188 6.035156 12.621094 5.890625 12.472656 L 1.28125 7.851562 L 14.625 7.851562 C 14.832031 7.851562 15 7.707031 15 7.5 C 15 7.292969 14.832031 7.148438 14.625 7.148438 L 1.28125 7.148438 L 5.890625 2.527344 C 5.964844 2.453125 6 2.351562 6 2.253906 C 6 2.160156 5.964844 2.058594 5.890625 1.988281 C 5.742188 1.839844 5.507812 1.835938 5.359375 1.984375 Z M 5.359375 1.984375 "
            ></path>
          </g>
        </svg>{" "}
        Partners List
      </a>

      <div className="container-nombre-Logo">
        <div className="nombre-Logo">
          <div className="contenedor-logo">
            <div className="div-logo">
              <span className="span-logo">
                <img src={imgSrc} alt={companyName} />
              </span>
            </div>
          </div>
          <h1 className="nombre-partner">{companyName}</h1>
        </div>
      </div>

      <div className="container-info-partner">
        <div className="container-left-info">
          <div className="content-left-info">
            <div className="left-info">
              <div className="header-left-info">
                <div className="divimg-left-info">
                  <span>
                    <img
                      src="https://chatby.io/images/chatby-silver-partner.png"
                      alt={companyName}
                    />
                  </span>
                </div>
                <div className="divname-left-info">{companyName}</div>
              </div>
              <div className="content-center-left-info">
                <i className="fa-solid fa-house-flag"></i> {companyCountry}
              </div>
              <div className="content-center-left-info">
                <i className="fa-solid fa-medal"></i> {classification}
              </div>
              <div className="content-center-left-info">
                <i className="fa-solid fa-globe"></i>{" "}
                <a href="https://paraemprendedores.pe/" target="_blank">
                  {Url}
                </a>
              </div>
            </div>
            <div className="div-button-info">
              <button onClick={toggleModal}>Contact Partner</button>
            </div>
          </div>
        </div>
        <div className="container-right-info">
          <div className="content-right-info">
            <div className="about-content">
              <div className="title-about">Acerca de:</div>
              <p>{companyAbout}.</p>
            </div>
          </div>
        </div>
      </div>
      {isModalOpen && (
        <div className="modal show d-block" tabIndex="-1" role="dialog">
          <div
            className="modal-dialog modal-dialog-scrollable modal-lg"
            role="document"
          >
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Contact Partner</h5>
                <button
                  type="button"
                  className="close"
                  aria-label="Close"
                  onClick={toggleModal}
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                {mensajeSubmit && (
                  <div className="alert alert-success" role="alert">
                    {mensajeSubmit}
                  </div>
                )}
                <form onSubmit={handleSubmit}>
                  <div className="columna-form">
                    <div className="form-group divinput">
                      <label htmlFor="firstName">Nombres*</label>
                      <input
                        type="text"
                        className="form-control"
                        id="first_name"
                        placeholder="Juan Manuel"
                        required
                        value={formData.first_name}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="form-group divinput">
                      <label htmlFor="lastName">Apellidos*</label>
                      <input
                        type="text"
                        className="form-control"
                        id="last_name"
                        placeholder="Perez Lopez"
                        required
                        value={formData.last_name}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="columna-form">
                    <div className="form-group divinput">
                      <label htmlFor="company">Empresa*</label>
                      <input
                        type="text"
                        className="form-control"
                        id="business_name"
                        placeholder="Happy Store"
                        required
                        value={formData.business_name}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="form-group divinput">
                      <label htmlFor="workEmail">Email*</label>
                      <input
                        type="email"
                        className="form-control"
                        id="email"
                        placeholder="juan@gmail.com"
                        required
                        value={formData.email}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="columna-form">
                    <div className="form-group divinput">
                      <label htmlFor="whatsapp">WhatsApp</label>
                      <div className="content-whatsapp">
                        <ReactSelect
                          id="country"
                          className="select-pais"
                          value={options.find(
                            (option) => option.value === countryCode
                          )}
                          onChange={handleCountryChange}
                          options={options}
                          placeholder="Selecciona un País"
                          getOptionLabel={(option) => (
                            <img
                              src={
                                flagsLoading
                                  ? "placeholder.png"
                                  : flags[option.value] || "default_flag.png"
                              }
                              alt={`${option.label} flag`}
                              style={{ width: "24px", height: "16px" }}
                            />
                          )}
                          getOptionValue={(option) => option.value}
                        />
                        <input
                          type="tel"
                          className="form-control"
                          id="whatsapp"
                          placeholder="123456789"
                          value={formData.whatsapp}
                          pattern="[0-9]*"
                          onInput={(e) => {
                            const { value } = e.target;
                            if (/^\d*$/.test(value)) {
                              handleChange(e);
                            }
                          }}
                        />
                      </div>
                    </div>
                    <div className="form-group divinput">
                      <label htmlFor="website">Pagina Web</label>
                      <input
                        type="text"
                        className="form-control"
                        id="website"
                        placeholder="www.minegocio.com"
                        value={formData.website}
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  <div className="columna-form">
                    <div className="form-group divinput-100">
                      <label htmlFor="description-project">
                        Descripción del proyecto*
                      </label>
                      <textarea
                        name="description-project"
                        id="project_description"
                        className="form-control"
                        placeholder="Escribe una breve descripción de tus requerimientos"
                        value={formData.project_description}
                        onChange={handleChange}
                      ></textarea>
                    </div>
                  </div>
                  <button type="submit" className="boton-enviar-formulario">
                    Enviar
                  </button>
                </form>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={toggleModal}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default EmpresaPerfil;